const WORKSPACE_LOGIN_STATUS_KEY_BASE = 'workspace_login_status';
export const WorkspaceLoginStatusKeyFactory = {
    all: () => [WORKSPACE_LOGIN_STATUS_KEY_BASE],
    byWorkspace: (workspaceId) => [
        WORKSPACE_LOGIN_STATUS_KEY_BASE,
        workspaceId,
    ],
};
